import { makeAutoObservable } from 'mobx'

class TaskStore {
  tasks: Function[]
  ids: Record<string, number>

  constructor() {
    this.tasks = []
    this.ids = {}
    makeAutoObservable(this)
  }

  private addTask = (task: Function, nameId: string) => {
    this.tasks = [...this.tasks, task]
    this.ids = { ...this.ids, [nameId]: this.tasks.length - 1 }
  }

  updateTask = (task: Function, nameId: string) => {
    const id = this.ids[nameId]
    if (id) {
      this.tasks[id] = task
    } else {
      this.addTask(task, nameId)
    }
  }

  clear = () => {
    this.tasks = []
    this.ids = {}
  }
}

export const taskStore = new TaskStore()
